import React from 'react';
import { Mail, MessageSquare, MapPin } from 'lucide-react';
import { PageHeader } from '../components/Layout';
import { GlassCard, Button, AppBadge } from '../components/ui';
export const ContactPage = () => {
  return <div className="min-h-screen bg-[#050810]" data-id="element-199">
      <PageHeader title="Contact Us" description="Get in touch with the KDX team for support or inquiries." data-id="element-200" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-201">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-202">
          {/* Contact Information */}
          <div data-id="element-203">
            <h2 className="text-3xl font-bold text-white mb-6" data-id="element-204">
              We'd love to hear from you
            </h2>
            <p className="text-gray-400 mb-10 leading-relaxed text-lg" data-id="element-205">
              Whether you have a question about services, need support with a
              transaction, or want to provide feedback, our team is ready to
              assist you.
            </p>

            <div className="space-y-8 mb-12" data-id="element-206">
              <div className="flex items-start gap-4" data-id="element-207">
                <div className="w-12 h-12 rounded-xl bg-purple-500/20 flex items-center justify-center shrink-0" data-id="element-208">
                  <Mail className="w-6 h-6 text-purple-400" data-id="element-209" />
                </div>
                <div data-id="element-210">
                  <h3 className="text-white font-bold mb-1 text-lg" data-id="element-211">
                    Support Email
                  </h3>
                  <p className="text-gray-400 text-sm mb-2" data-id="element-212">
                    For all support inquiries:
                  </p>
                  <a href="mailto:kdx.limited.ng@gmail.com" className="text-purple-400 hover:underline text-lg" data-id="element-213">
                    info@kdx.ng
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-214">
                <div className="w-12 h-12 rounded-xl bg-blue-500/20 flex items-center justify-center shrink-0" data-id="element-215">
                  <MessageSquare className="w-6 h-6 text-blue-400" data-id="element-216" />
                </div>
                <div data-id="element-217">
                  <h3 className="text-white font-bold mb-1 text-lg" data-id="element-218">
                    Customer Support
                  </h3>
                  <p className="text-gray-400 text-sm mb-2" data-id="element-219">
                    Need help with an order or account?
                  </p>
                  <a href="/support" className="text-blue-400 hover:underline" data-id="element-220">
                    Visit Help Center
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-221">
                <div className="w-12 h-12 rounded-xl bg-pink-500/20 flex items-center justify-center shrink-0" data-id="element-222">
                  <MapPin className="w-6 h-6 text-pink-400" data-id="element-223" />
                </div>
                <div data-id="element-224">
                  <h3 className="text-white font-bold mb-1 text-lg" data-id="element-225">
                    Business Address
                  </h3>
                  <p className="text-gray-400 text-sm" data-id="element-226">
                    KDX Limited
                    <br data-id="element-227" />
                    Nigeria
                  </p>
                </div>
              </div>
            </div>

            <div className="pt-8 border-t border-white/10" data-id="element-228">
              <h3 className="text-white font-bold mb-4 text-lg" data-id="element-229">
                Download the App
              </h3>
              <div className="flex gap-4" data-id="element-230">
                <AppBadge platform="ios" className="scale-90 origin-left" data-id="element-231" />
                <AppBadge platform="android" className="scale-90 origin-left" data-id="element-232" />
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <GlassCard className="p-8" data-id="element-233">
            <h3 className="text-2xl font-bold text-white mb-6" data-id="element-234">
              Send us a message
            </h3>
            <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-235">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-236">
                <div className="space-y-2" data-id="element-237">
                  <label className="text-sm font-medium text-gray-300" data-id="element-238">
                    First Name
                  </label>
                  <input type="text" className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-purple-500 transition-colors" placeholder="John" data-id="element-239" />
                </div>
                <div className="space-y-2" data-id="element-240">
                  <label className="text-sm font-medium text-gray-300" data-id="element-241">
                    Last Name
                  </label>
                  <input type="text" className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-purple-500 transition-colors" placeholder="Doe" data-id="element-242" />
                </div>
              </div>

              <div className="space-y-2" data-id="element-243">
                <label className="text-sm font-medium text-gray-300" data-id="element-244">
                  Email Address
                </label>
                <input type="email" className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-purple-500 transition-colors" placeholder="john@example.com" data-id="element-245" />
              </div>

              <div className="space-y-2" data-id="element-246">
                <label className="text-sm font-medium text-gray-300" data-id="element-247">
                  Subject
                </label>
                <select className="w-full bg-[#0a0e27] border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-purple-500 transition-colors appearance-none" data-id="element-248">
                  <option data-id="element-249">General Inquiry</option>
                  <option data-id="element-250">Transaction Support</option>
                  <option data-id="element-251">Account Issue</option>
                  <option data-id="element-252">Refund Request</option>
                  <option data-id="element-253">Partnership</option>
                  <option data-id="element-254">Other</option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-255">
                <label className="text-sm font-medium text-gray-300" data-id="element-256">
                  Message
                </label>
                <textarea rows={5} className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-purple-500 transition-colors resize-none" placeholder="How can we help you?" data-id="element-257"></textarea>
              </div>

              <Button className="w-full" data-id="element-258">Send Message</Button>
            </form>
          </GlassCard>
        </div>
      </div>
    </div>;
};